import {Col, Row, Button} from 'antd';
import {BsFillArrowLeftCircleFill} from 'react-icons/bs';
import {FaCube} from 'react-icons/fa';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import {useNavigate} from 'react-router-dom';
import {OrderDetailsDto} from '../../../../../shared/services/orders/dto/order-details-dto';
import {useIntl} from 'react-intl';
import MainUtils from 'src/shared/utils/main';

interface IOrderDetailsHeaderProps {
  orderDetails?: OrderDetailsDto;
  onOpenTrackShipmentModal: Function;
}

const OrderDetailsHeader = (props: IOrderDetailsHeaderProps) => {
  const {
    orderDetails,
    onOpenTrackShipmentModal,
  } = props;

  const navigate = useNavigate();

  const {messages} = useIntl();

  return (
    <Row gutter={[10, 10]}>
      <Col span={10}>
        <div className='text-title'>
          <span className='icon-title'>
            <FaCube />
          </span>
          {orderDetails?.OrderNumber
            ? `${messages['orders.orderDetails.title'].toString()} - ${
                orderDetails?.OrderNumber
              }`
            : `${messages['orders.orderDetails.title'].toString()}`}

          <small className='back-to-list'>
            <BsFillArrowLeftCircleFill className='back-to-icon' />
            <a
              onClick={() => {
                navigate('/orders/orders-list');
              }}>
              <IntlMessages id='orders.orderDetails.backToOrdersList' />
            </a>
          </small>
        </div>
      </Col>
      <Col span={14}>
        <Row justify='end' gutter={[20, 0]}>
          {!MainUtils.isEmptyValue(orderDetails?.shipmentNumber) && (
            <Col>
              <Button
                onClick={() => onOpenTrackShipmentModal()}
                size='small'
                type='primary'
                className='add-button'>
                <IntlMessages id='orders.orderDetails.orderItems.trackShipment' />
              </Button>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default OrderDetailsHeader;